import { useMutation } from 'react-query';

import { UpdateComment, updateComment } from '../utils/backend-api/comments';

export default function useCommentUpdate() {
  const { mutate, mutateAsync, data, isLoading, isError } = useMutation((values: UpdateComment) =>
    updateComment(values)
  );
  return { mutate, mutateAsync, data, isLoading, isError };
}
